/**
 * PilotHint component.
 */
import ArrowRightIcon from '@components/atoms/icons/arrowRight';
import Button from '@components/elements/buttons/genericButton';
import Focus from '@shared/types/enums/focus';
import PilotHintArrowContainer from '@components/atoms/container/pilotHintArrowContainer';
import PilotHintButtonContainer from '@components/atoms/container/pilotHintButtonContainer';
import PilotHintContainer from '@components/atoms/container/pilotHintContainer';
import PilotHintText from '@components/atoms/text/pilotHintText';
import PilotHintTextContainer from '@components/atoms/container/pilotHintTextContainer';

/**
 * PilotHint props.
 */
interface Props {
  button: { action?: () => void; text: string };
  text: { left: string; right: string };
}

/**
 * Displays the pilot hint text and button.
 */
export default function PilotHint({ button, text }: Props) {
  return (
    <PilotHintContainer>
      {/* Text */}
      <PilotHintTextContainer>
        <PilotHintText>{text.left}</PilotHintText>
        <PilotHintArrowContainer>
          <ArrowRightIcon />
        </PilotHintArrowContainer>
        <PilotHintText>{text.right}</PilotHintText>
      </PilotHintTextContainer>
      {/* Button */}
      <PilotHintButtonContainer>
        <Button {...button} focus={Focus.ZAPPER} />
      </PilotHintButtonContainer>
    </PilotHintContainer>
  );
}
